import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { type ActionMethods, type UserSelfPageData } from '..';
import PageTitle from '../PageTitle';
import { ActionButton } from '../styled';
import useWebAuthnSettingsData from './useWebAuthnSettingsData';
import WebAuthnSettingsContent from './WebAuthnSettingsContent';

export const useWebAuthnSettingsPageData = (actions: ActionMethods) => {
    const { t } = useTranslation('userSelf');
    const { keysData, revokeKey, setupNewKey } = useWebAuthnSettingsData();

    if (!keysData) {
        return null;
    }

    const page: UserSelfPageData = {
        type: 'webAuthnSettings',
        title: (
            <PageTitle
                extra={<ActionButton icon={<PlusOutlined />} onClick={setupNewKey} type="link" />}
                title={t('userSelf:webAuthnSettings.title')}
            />
        ),
        body: <WebAuthnSettingsContent data={keysData} revoke={revokeKey} />,
        onMenuItemClicked: actions.goToWebAuthnSettings,
        onCloseOrBackClicked: actions.goBackToViewProfile,
    };

    return page;
};

export default useWebAuthnSettingsPageData;
